import { INoDataResponse } from '@api/interfaces';
import apiClient from '../axios';
import {
  Credentials,
  IActivateAccountParams,
  IForgotPasswordParams,
  IResetPasswordParams,
  IRevokeAccountParams,
} from './interfaces';
import { AxiosResponse } from 'axios';

export const login = async (credentials: Credentials): Promise<void> => {
  await initCsrfCookie();
  await apiClient.post('/login', JSON.stringify(credentials), {
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const logout = async (): Promise<void> => {
  await apiClient.post('/logout', {
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const initCsrfCookie = async (): Promise<void> => {
  await apiClient.get('/sanctum/csrf-cookie');
};

export const activateAccount = async (
  activateAccountParams: IActivateAccountParams
): Promise<string> => {
  const response: AxiosResponse<INoDataResponse> = await apiClient.post(
    '/account/activate',
    activateAccountParams
  );

  return response.data.message;
};

export const resetPassword = async (
  params: IResetPasswordParams
): Promise<string> => {
  const response: AxiosResponse<INoDataResponse> = await apiClient.post(
    '/account/reset-password',
    params
  );

  return response.data.message;
};

export const revokeAccount = async (
  revokeAccountParams: IRevokeAccountParams
): Promise<string> => {
  const response: AxiosResponse<INoDataResponse> = await apiClient.post(
    `/manage/members/${revokeAccountParams.memberSlug}/account/revoke`,
    {
      reason: revokeAccountParams.reason,
    }
  );

  return response.data.message;
};

export const forgotPassword = async (
  resetPasswordParams: IForgotPasswordParams
): Promise<string> => {
  const response: AxiosResponse<INoDataResponse> = await apiClient.post(
    '/account/forgot-password',
    resetPasswordParams
  );

  return response.data.message;
};
